var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d61428ec4ef88609e5392187f367d57adc7cfdf6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["trackr-jackr@bridgetown-collective"]={id:"d61428ec4ef88609e5392187f367d57adc7cfdf6"};
      